import { isEqual, isPlainObject, mergeWith } from "lodash-es"

const SAME_TAG = "9Xg3j"
type DifferenceMapConfig = {
  /**
   * Will always return the newValue irr-respective of what is changed for the listed keys
   * eg. ["id","users"]
   */
  leaveUnchanged?: string[]
}
function differenceMap(
  oldObject: any,
  newObject: any,
  config?: DifferenceMapConfig
) {
  const differenceObj = mergeWith(
    oldObject,
    newObject,
    (oldValue, newValue, key) => {
      if (isEqual(oldValue, newValue) && key !== "id") {
        // We use a random id to demonstrate the values that are same
        // because tagging with null or undefined may have consequences
        return SAME_TAG
      } else if (config?.leaveUnchanged?.includes(key)) {
        return newValue
      }
    }
  )

  function removeKey(obj) {
    if (isPlainObject(obj)) {
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          const element = obj[key]

          if (element === SAME_TAG) {
            delete obj[key]
          } else {
            removeKey(element)
          }
        }
      }
    } else if (Array.isArray(obj)) {
      for (let i = 0; i < obj.length; i++) {
        const element = obj[i]
        if (element === SAME_TAG) {
          obj.splice(i, 1)
          i--
        } else {
          removeKey(element)
        }
      }
    }
  }
  removeKey(differenceObj)
  return differenceObj
}

export default differenceMap
